import { AlertBlockWarning } from '@klarna/bubble-ui';
import { hooks as i18nHooks } from 'mage-i18n';
import { TrackImpression } from 'mage-insights';
import React from 'react';
import styled from 'styled-components';
import { useAccessController } from '../../controllers/AccessController';
import { useMidController } from '../../controllers/MidController';
import { usePluginController } from '../../controllers/PluginController';
import { useApiKey } from '../../controllers/useApiKey';
const TRANSLATION_PREFIX = 'home-fe.boosters-plugin.instructions.api-key';
const MANAGE_API_KEYS_PATH = '/settings/api-credentials';
const Container = styled.div.withConfig({ displayName: "Container", componentId: "sc-1rijnzx" }) `
  margin-bottom: 24px;
`;
const navigateToSettings = () => {
    window.location.href = MANAGE_API_KEYS_PATH;
};
export default function ApiKeyBanner() {
    const t = i18nHooks.useTranslator();
    const { canCreateApiKey } = useAccessController();
    const { hasAlreadyActiveKeys } = useApiKey();
    const { pluginId } = usePluginController();
    const { selectedMid } = useMidController();
    const event = {
        category: `boost-home/plugin-guide/${pluginId}/active-api-key-warning`,
        action: 'impression',
        label: selectedMid !== null && selectedMid !== void 0 ? selectedMid : undefined
    };
    const mustDisplayBanner = canCreateApiKey && hasAlreadyActiveKeys;
    if (!mustDisplayBanner) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(TrackImpression, { event: event },
            React.createElement(Container, null,
                React.createElement(AlertBlockWarning, { content: [t(`${TRANSLATION_PREFIX}.active-warning.content`)], linkLabel: t(`${TRANSLATION_PREFIX}.active-warning.link`), onLinkClick: navigateToSettings })))));
}
